import React from "react";

const Loader = () => <div className="spinner">Loading ...</div>;

export default Loader;
